import { Injectable } from '@angular/core';

import { DataReactionWithRelations } from '@osos/shared/api';
import { FactoryBase } from '../../bases/factory/factory-base';
import { ParserFactory } from '../../services';

import { DataReactionWithRelationsPresenterModel } from '@osos/shared/types';
import { DataEntityTiggerParserV1Service } from '../../parsers/data-entity-trigger-parser/data-entity-tigger-parser-v1.service';

@Injectable()
export class DataReactionWithRelationsFactoryService extends FactoryBase<
  DataReactionWithRelations,
  DataReactionWithRelationsPresenterModel
> {
  constructor(
    parserFactory: ParserFactory,
    parser_v1: DataEntityTiggerParserV1Service,
  ) {
    super(parserFactory);
    // register the related parsers within the parser factory:
    parserFactory.register(parser_v1);
  }

  createDataModel(
    presenter: DataReactionWithRelationsPresenterModel,
  ): DataReactionWithRelations {
    //@TODO use presenter.specificationVersion
    const parser = this.getParser(
      DataReactionWithRelations,
      DataReactionWithRelationsPresenterModel,
    );
    const result = parser.getDataModel(presenter);
    return result;
  }

  createPresenterModel(
    model: DataReactionWithRelations,
  ): DataReactionWithRelationsPresenterModel {
    //@TODO use model.specificationVersion
    const parser = this.getParser(
      DataReactionWithRelations,
      DataReactionWithRelationsPresenterModel,
    );
    const result = parser.getPresenterModel(model);
    return result;
  }
}
